import { render } from "./LightboxProductsIdentifiedSkeleton.vue?vue&type=template&id=6de52c25&scoped=true"
import script from "./LightboxProductsIdentifiedSkeleton.vue?vue&type=script&lang=js"
export * from "./LightboxProductsIdentifiedSkeleton.vue?vue&type=script&lang=js"

import "./LightboxProductsIdentifiedSkeleton.vue?vue&type=style&index=0&id=6de52c25&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6de52c25"]])

export default __exports__